import './polyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueProgressBar from 'vue-progressbar'
import App from './App'
import router from './router/index'
import './assets/fontawesome/js/all.min.js'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VueProgressBar, {
  color: '#20a8d8',
  failedColor: 'red',
  height: '2px'
})
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
Vue.http.options.credentials = false
Vue.http.headers.common['content-type'] = 'application/json'